import { useLingui } from '@lingui/react'
import { type FunctionComponent } from 'react'

import { TENANT_IT } from 'shared/consts/tenants'
import type {
  CartControllerCartShippingDetailV2,
  CartControllerSellerGroupV2,
} from 'types/api/cart'
import Price from 'views/components/atoms/Price'
import './SellerShippingAddressBox.scss'
import ImageRow from 'views/components/molecules/ImageRow'
import Notification from 'views/components/molecules/Notification'
import { imageItems } from 'views/components/organisms/Cart/helper/imageItems'
import {
  mapShippingDetail,
  showFreeShippingThreshold,
} from 'views/components/organisms/Cart/ProductListCart/SellerShippingAddressBox/helpers'
import Tenant from 'views/components/utils/Tenant'
import TransWithHtml from 'views/components/utils/TransWithHtml'

type PropTypes = {
  sellerGroups: CartControllerSellerGroupV2[]
  shippingDetail: CartControllerCartShippingDetailV2[]
  currency: string
}

const DeliveryCostModalContent: FunctionComponent<PropTypes> = ({
  sellerGroups,
  shippingDetail,
  currency,
}: PropTypes) => {
  const { i18n } = useLingui()
  return (
    <>
      <div>
        {sellerGroups
          .map(seller =>
            mapShippingDetail(
              seller as CartControllerSellerGroupV2,
              shippingDetail as CartControllerCartShippingDetailV2[]
            )
          )
          .map(seller => (
            <div
              className="u-background-color--background a-box--medium u-border-radius u-margin-large--bottom m-Modal__DeliveryCost__content"
              key={`DeliveryCostModal-${seller.sellerName}-${seller.sellerGroupId}`}
            >
              <div className="l-flex@medium o-modalBox-rightContent u-padding-large--bottom o-modalBox__DeliveryCost">
                <div className="a-box u-no-padding">
                  <div className="a-h3 u-margin-xx-small--bottom u-font-weight--bold m-Modal__DeliveryCost__title">
                    <TransWithHtml
                      text={i18n._('checkout.ShipmentBySeller.seller', {
                        seller: seller.sellerName?.toUpperCase(),
                      })}
                    />
                  </div>
                  {seller?.shippingDetail?.freeShippingThreshold &&
                    showFreeShippingThreshold(
                      seller.shippingDetail,
                      seller.subAmount
                    ) && (
                      <div>
                        <ul className="a-list-reset l-flex o-modalBox-rightContent">
                          <li className="u-color--grey">
                            <TransWithHtml
                              text={i18n._('general.label.shippingBargain')}
                            />
                            <Price
                              amount={
                                seller.shippingDetail.freeShippingThreshold
                              }
                              currency={currency}
                            />
                          </li>
                        </ul>
                      </div>
                    )}
                </div>
              </div>
              <div className="u-no-padding o-modalBox-rightContent u-padding-large--bottom u-border--bottom@medium u-border-color--greySky o-modalBox__productImages">
                <ImageRow items={imageItems(seller, true)} keepImageSize />
              </div>
              <ul className="a-list-reset l-flex o-modalBox-rightContent u-padding-small--bottom u-padding-large--top@medium u-font-weight--bold o-modalBox__subtotal">
                <li className="m-Modal__DeliveryCost__subtotal-text">
                  <TransWithHtml text={i18n._('basket.subTotal')} />
                </li>
                <li className="m-Modal__DeliveryCost__subtotal-price">
                  <Price amount={seller.subAmount} currency={currency} />
                </li>
              </ul>
              {seller.shippingDetail && (
                <ul className="a-list-reset l-flex o-modalBox-rightContent">
                  <li>
                    <TransWithHtml text={i18n._('basket.shippingCosts')} />
                  </li>
                  <li>
                    {seller.shippingDetail.shippingCost === 0 ? (
                      <div className="u-color--positive">
                        <TransWithHtml
                          text={i18n._(
                            'checkout.ShippingServiceList.shippingCompany.freeDelivery'
                          )}
                        />
                      </div>
                    ) : (
                      <div>
                        <Price
                          amount={seller.shippingDetail.shippingCost}
                          currency={currency}
                        />
                      </div>
                    )}
                  </li>
                </ul>
              )}
            </div>
          ))}
      </div>
      <Tenant not tenant={[TENANT_IT]}>
        {() => (
          <Notification label={i18n._('cart.modal.shippinginfo')} type="info" />
        )}
      </Tenant>
    </>
  )
}

export default DeliveryCostModalContent
